import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule} from '@angular/router';
import {taxHubRoutes} from '@features/tax-hub/tax-hub.routes';
import {CommandService} from '@core/services/command.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {TaxHubDynamicComponentHelper} from '@features/tax-hub/tax-hub-dynamic-component-helper';
import {WebsiteUsageReportHandler} from '@features/tax-hub/website-usage-report.handler';
import {WebsiteUsageReportByArticleHandler} from '@features/tax-hub/website-usage-report-by-article.handler';
import {Api} from '@shared/constants/common-field.constants';
import {PlatformToolOrbitaxUserAnalyticsHandler} from '@features/tax-hub/platform-tool-orbitax-user-analytics.handler';


@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(taxHubRoutes)
  ]
})
export class TaxHubModule {
  constructor(private commandService: CommandService,
              private websiteUsageReportHandler: WebsiteUsageReportHandler,
              private websiteUsageReportByArticleHandler: WebsiteUsageReportByArticleHandler,
              private platformToolOrbitaxUserAnalyticsHandler: PlatformToolOrbitaxUserAnalyticsHandler
  ) {
    TaxHubDynamicComponentHelper.init();
    TaxHubDynamicComponentHelper.register('WebsiteUsageReportHandler', websiteUsageReportHandler);
    TaxHubDynamicComponentHelper.register('WebsiteUsageReportByArticleHandler', websiteUsageReportByArticleHandler);
    TaxHubDynamicComponentHelper.register('PlatformToolOrbitaxUserAnalyticsHandler', platformToolOrbitaxUserAnalyticsHandler);

    let command = new PlatformCommand('CreateUsageReportLinkCommand', Api.TaxHubApi);
    command.fieldValues['SelectedTabId'] = 'WebsiteUsageReportByCompany';
    this.commandService.registrPlatformLinkCommand('/administration/usage-report/orbitax-website', command);

    command = new PlatformCommand('CreateUsageReportLinkCommand', Api.TaxHubApi);
    command.fieldValues['SelectedTabId'] = 'WebsiteUsageReport';
    this.commandService.registrPlatformLinkCommand('/administration/usage-report/orbitax-website/by-user', command);

    command = new PlatformCommand('CreateUsageReportLinkCommand', Api.TaxHubApi);
    command.fieldValues['SelectedTabId'] = 'WebsiteUsageReportByFeature';
    this.commandService.registrPlatformLinkCommand('/administration/usage-report/orbitax-website/by-feature', command);

    command = new PlatformCommand('CreateUsageReportLinkCommand', Api.TaxHubApi);
    command.fieldValues['SelectedTabId'] = 'WebsiteUsageReportByArticle';
    this.commandService.registrPlatformLinkCommand('/administration/usage-report/orbitax-website/by-article', command);

    command = new PlatformCommand('OrbitaxUserAnalyticsToolLinkCommand', Api.TaxHubApi);
    this.commandService.registrPlatformLinkCommand('/administration/usage-report/orbitax-itp', command);

    this.registerPlatformLinkCommands(this.commandService);
  }

  private registerPlatformLinkCommands(commandService: CommandService) {
    commandService.registrPlatformLinkCommand('/administration/usage-report/orbitax-website/by-article/:ArticleId',
      this.getPlatformLinkCommand('CreateUsageReportByArticleViewLinkCommand'));
    commandService.registrPlatformLinkCommand('/administration/usage-report/orbitax-website/by-feature/:FeatureId',
      this.getPlatformLinkCommand('CreateUsageReportByFeatureViewLinkCommand'));
    commandService.registrPlatformLinkCommand('/administration/usage-report/orbitax-website/by-company/:RowId',
      this.getPlatformLinkCommand('CreateUsageReportByCompanyViewLinkCommand'));
  }

  private getPlatformLinkCommand(commandName: string, api?: string) {
    const command = new PlatformCommand(commandName,  api ? api : Api.TaxHubApi);
    return command;
  }
}
